import script from "./BlogIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlogIndex.vue?vue&type=script&setup=true&lang=ts"

import "./BlogIndex.vue?vue&type=style&index=0&id=2cc538d7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cc538d7"]])

export default __exports__